// extracted by mini-css-extract-plugin
module.exports = {"host":"Actions_host__2pBPL","panel":"Actions_panel__1rBxJ"};